export default __webpack_public_path__ + "static/media/735.03e4dd56.png";